import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full px-4 lg:px-8 lg:pr-0 md:flex items-center text-left justify-center',
);

export const Title = w.h1(
  'text-4xl md:text-5xl xl:text-7xl text-[var(--azul)]'
)

export const SubTitle = w.p(
  'text-xl md:text-2xl xl:text-4xl mt-4 text-[var(--azul)]'
)

export const Text = w.ol(
  'text-xl lg:text-2xl mt-10 md:mt-12 list-decimal list-inside'
)

export const Btn = w.button(
  'relative bg-[var(--azul)] rounded-full text-white font-bold px-12 py-3 mt-16'
)